import { useQuery } from '@tanstack/react-query';
import apiClient from "./apiClient";

export interface CheeseItem {
  id: number;
  fromageNom: string;
  laitDescription: string;
  familleDescription: string;
  traitementDescription: string;
  paysDescription: string;
  regionDescription: string;
  quantiteTotale: number;
  quantiteAnnee: number;
  nombreAchat: number;
  nombreAchatAnnee: number;
  dateDernierAchat: string;
  favorite: boolean;
  disliked: boolean;
}


const getCheeses = async (): Promise<CheeseItem[] | null> => {
  try {
    const response = await apiClient.get(`/fromages`);
    return response.data;
  } catch (error) {
    // console.error("Failed to fetch purchase history:", error);
    return null;
  }
};

export const useCheeses = () => {
  return useQuery({
    queryKey: ['cheeses'],
    queryFn: getCheeses,
  });
};

export default getCheeses;